import { HHTextField } from '@hinge-health/react-component-library';
import Autocomplete from '@mui/material/Autocomplete';
import { Controller } from 'react-hook-form';
import { SubmissionStatusEnum } from '../../types';
import { capitalizeFirstLetterAndSpaceSnakeString } from '../../utils/bills-utils';
import {
  StatusFilterLabelText,
  SubmissionStatusFilterProps,
} from './filter-types';

export const submissionStatusTypesSelectOptions = Object.values(
  SubmissionStatusEnum,
).map(status => ({
  value: status,
  label: capitalizeFirstLetterAndSpaceSnakeString(status.toLowerCase()),
}));

export const SubmissionStatusFilter = ({
  control,
  name = 'submissionStatusTypes',
  disabled = false,
}: SubmissionStatusFilterProps): JSX.Element => (
  <Controller
    control={control}
    name={name}
    render={({
      field: { onChange, value },
      fieldState: { error },
    }): JSX.Element => (
      <Autocomplete
        multiple
        options={submissionStatusTypesSelectOptions}
        size="small"
        disabled={disabled}
        sx={{ minWidth: 230, maxWidth: 230 }}
        limitTags={1}
        blurOnSelect={true}
        onChange={(_, newValue): void => onChange(newValue)}
        value={value}
        getOptionLabel={(option): string => option.label}
        isOptionEqualToValue={(option, value): boolean =>
          option.value === value.value
        }
        renderInput={(params): JSX.Element => (
          <HHTextField
            {...params}
            hhVariant="variant-bypass"
            variant="standard"
            label={StatusFilterLabelText.SUBMISSION_STATUS}
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
    )}
  />
);
